import { maybeGetDocument } from './globals';
export function readCookie(name) {
    var cookieValue = getCookieByName(name);
    if (cookieValue) {
        return cookieValue.split('=')[1];
    }
    return '';
}
function loadCookies() {
    var documentObj = maybeGetDocument();
    if (documentObj && documentObj.cookie) {
        return decodeURIComponent(documentObj.cookie).split(';');
    }
    return [];
}
function getCookieByName(name) {
    return loadCookies().filter(function (cookie) { return name === cookie.split('=')[0].trim(); })[0];
}
//# sourceMappingURL=cookies.js.map